import { useEffect, useId, useState } from "react";

export default function StudioGa4ConnectModal({
  open,
  status = null,
  isSaving = false,
  errorMessage = "",
  onClose,
  onSave,
}) {
  const titleId = useId();
  const [enabled, setEnabled] = useState(true);
  const [measurementId, setMeasurementId] = useState("");
  const [propertyId, setPropertyId] = useState("");

  useEffect(() => {
    if (!open) {
      return;
    }
    setEnabled(status?.enabled !== false);
    setMeasurementId(status?.measurementId || "");
    setPropertyId(status?.propertyId || "");
  }, [open, status]);

  if (!open) {
    return null;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    onSave({
      enabled,
      measurementId: measurementId.trim(),
      propertyId: propertyId.trim(),
    });
  };

  return (
    <div className="cv-analytics__modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="cv-analytics__modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(event) => event.stopPropagation()}
      >
        <header className="cv-analytics__modal-header">
          <div>
            <p className="cv-analytics__modal-eyebrow">Google Analytics 4</p>
            <h2 id={titleId} className="cv-analytics__modal-title">
              {status?.measurementId || status?.propertyId
                ? "Update Google Analytics"
                : "Connect Google Analytics"}
            </h2>
          </div>
          <button type="button" className="cv-analytics__toolbar-btn" onClick={onClose}>
            Close
          </button>
        </header>

        <form className="cv-analytics__modal-body" onSubmit={handleSubmit}>
          <p className="cv-analytics__modal-lede">
            Connect this Client View to a GA4 property. The Measurement ID is used on the public
            site. The Property ID is used to sync reports into Studio.
          </p>

          <label className="cv-analytics__modal-toggle">
            <input
              type="checkbox"
              checked={enabled}
              onChange={(event) => setEnabled(event.target.checked)}
            />
            <span>Enable Google Analytics for this Client View</span>
          </label>

          <label className="cv-analytics__modal-field">
            <span>Measurement ID</span>
            <input
              type="text"
              value={measurementId}
              onChange={(event) => setMeasurementId(event.target.value)}
              placeholder="G-XXXXXXXXXX"
              autoComplete="off"
              spellCheck={false}
            />
            <span className="cv-analytics__modal-hint">
              Google Analytics → Admin → Data streams → your web stream.
            </span>
          </label>

          <label className="cv-analytics__modal-field">
            <span>GA4 Property ID</span>
            <input
              type="text"
              value={propertyId}
              onChange={(event) => setPropertyId(event.target.value)}
              placeholder="123456789"
              autoComplete="off"
              spellCheck={false}
            />
            <span className="cv-analytics__modal-hint">
              Google Analytics → Admin → Property settings. Needed to sync reports into this tab.
            </span>
          </label>

          {status?.credentialsPresent === false ? (
            <p className="cv-analytics__modal-note">
              Server service-account credentials are not configured yet. You can still save the
              Measurement ID for public tracking. Ask an admin to add Analytics Viewer credentials
              before report sync will work.
            </p>
          ) : null}

          {errorMessage ? (
            <p className="cv-analytics__error" role="alert">
              {errorMessage}
            </p>
          ) : null}

          <footer className="cv-analytics__modal-footer">
            <button type="button" className="cv-analytics__toolbar-btn" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="cv-analytics__toolbar-btn cv-analytics__toolbar-btn--primary"
              disabled={isSaving}
            >
              {isSaving ? "Saving…" : "Save connection"}
            </button>
          </footer>
        </form>
      </div>
    </div>
  );
}
